import { ContainerModule, interfaces } from 'inversify';
import { IReviewRejectionReasonBl, ReviewRejectionReasonBl } from './reviewRejectionReason.bl';
import { IReviewRejectReasonsStore, ReviewRejectReasonsStore } from './reviewRejectReasons.store';
import { IRejectionReasonService, RejectionReasonService } from './services/rejectionReason.service';

export const reviewRejectReasonsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IReviewRejectReasonsStore.$).to(ReviewRejectReasonsStore).inSingletonScope();
  bind(IRejectionReasonService.$).to(RejectionReasonService).inSingletonScope();
  bind(IReviewRejectionReasonBl.$).to(ReviewRejectionReasonBl).inSingletonScope();
});
